const STORAGE_KEYS = {trips : 'trips_filters'};
export default STORAGE_KEYS;
